Monitoring.Views.SocialContents ||= {}

class Monitoring.Views.SocialContents.SocialContentTwitterMediaView extends Backbone.View
  template: JST["backbone/templates/monitoring/social_contents_v2/social_content_twitter_media"]

  initialize: (options = {}) ->
    @mediaFiles = options.mediaFiles or []
    @canPlayMP4 = options.canPlayMP4
    @socialContent = options.socialContent
    @attachmetsFiles = @get_attachments(@mediaFiles)

  get_attachments:(medias)=>
    attachments = []
    _.map(medias, (media) =>
      attach_fact =  new Monitoring.Models.SocialContents.AttachmentFactory(media, @socialContent)
      attachment = attach_fact.get_attachment()
      attachments.push(attachment)
    )
    attachments

  render: ->
    @$el.html @template
      video: @_video()
      gif: @_gif()
      images: @_images()
      files: @_files()
      mediaAmount: @_mediaAmount()
    this

  _video: ->
    return null unless @canPlayMP4
    @attachmetsFiles.find((attachment) -> attachment.is_twitter_video())

  _gif: ->
    return null unless @canPlayMP4
    @attachmetsFiles.find((attachment) -> attachment.is_twitter_gif())

  _files: ->
    _.filter(@mediaFiles, (media)-> media.type == 'file')

  _images: ->
    return _.filter(@mediaFiles, (media)-> media.type != 'file') unless @canPlayMP4
    _.filter(@attachmetsFiles, (attachment)=> !(attachment.is_twitter_gif() || attachment.is_twitter_video()) && !(attachment.media && attachment.media.type == 'file'))

  _mediaAmount: ->
    @mediaFiles.length
